import { get } from 'axios'

const endpoint = '/audit-logs'

export const getAuditLogs = ({ offset, limit, entity, action, text }) => {
  const query = [`offset=${offset}`, `limit=${limit}`]
  if (entity) {
    query.push(`entity=${entity}`)
  }
  if (action) {
    query.push(`action=${action}`)
  }
  if (text && text !== '') {
    query.push(`text=${text}`)
  }
  return get(`${endpoint}?${query.join('&')}`)
}

export default {
  getAuditLogs,
}
